import {useEffect} from "react";
import {getCurrentLocation, locationBehaviors, locations} from "../../Utilities/Location";
import {isValidUser} from "../../Containers/User/userUtilities";

interface AuthorizeProps {
    fetchUser: () => void;
    isAdmin?: boolean;
    isLoggedIn: boolean;
    path: string;
    pathUrl: string;
    redirect: (path: string) => void;
    returnUrl?: string;
    setReturnUrl?: (url: string | undefined) => void;
    user: Record<string, unknown>;
}

export const Authorize = ({
                       fetchUser,
                       isAdmin = false,
                       isLoggedIn,
                       path,
                       pathUrl,
                       redirect,
                       returnUrl,
                       setReturnUrl,
                       user,
                   }: AuthorizeProps): null => {

    useEffect(() => {
        const currentLocation = getCurrentLocation(path)!;
        if (!isLoggedIn) {
            if (currentLocation[locationBehaviors.requiresAuthentication] || currentLocation[locationBehaviors.requiresAdminAuthentication]) {
                if (!currentLocation[locationBehaviors.doNotRedirectBack]) {
                    setReturnUrl?.(pathUrl);
                }
                redirect(locations.SIGN_IN.path);
            }
            return;
        }

        if (currentLocation[locationBehaviors.requiresAdminAuthentication] && !isAdmin) {
            redirect(locations.NOT_AUTHORIZED.path);
            return;
        }

        if (returnUrl) {
            redirect(returnUrl);
            setReturnUrl?.(undefined);
        } else if (currentLocation[locationBehaviors.redirectToDashboard]) {
            const homePath = locations.DASHBOARD.path;
            redirect(homePath);
        }

        // eslint-disable-next-line
    }, [isLoggedIn, path]);

    useEffect(() => {
        if (isLoggedIn && !isValidUser(user))
            fetchUser();
        // eslint-disable-next-line
    }, [user, isLoggedIn]);


    return null;
};
